import Vue from 'vue'
import 'view-design/dist/styles/iview.css'

import {
  Button,
  // Carousel, // 轮播图
  // CarouselItem,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Icon,
  Input,
  Message,
  Modal,
  Page,
  Table,
  Tabs,
  TabPane,
  Tooltip,
  Spin,
  Row
} from 'view-design'
// iview基础模块
const components = {
  Button,
  // Carousel,
  // CarouselItem,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Icon,
  Input,
  Message,
  Modal,
  Option,
  Page,
  Row,
  Spin,
  Table,
  Tabs,
  TabPane,
  Tooltip
}

const iviewModule = {
  ...components,
  // 不能和html标签重复的组件，添加别名(除了Switch、Circle在使用中必须是iSwitch、iCircle,其他都可以不加"i")
  iButton: Button,
  iCol: Col,
  iForm: Form,
  iInput: Input,
  iOption: Option,
  iTable: Table
}
// 循环注册全局组件
Object.keys(iviewModule).forEach(key => {
  Vue.component(key, iviewModule[key])
})

Vue.prototype.$Message = Message



// WEBPACK FOOTER //
// ./src/iview.js